


























































import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';

import { store } from '../store/edit';
import { editMutations } from '../store/types';

export default Vue.extend({
	name: 'Ostatni',
	components: {
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	props: {
		storeUri: { type: String, required: true },
	},
	data() {
		return {
			mutationsMappers: {
				nakladoveStredisko: `${this.storeUri}/${editMutations.NAKLADOVE_STREDISKO_SELECT}`,
			},
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
});
